import Vue from 'vue'
import Router from 'vue-router'


/**
 * 登录
 */
const Author = () => import(/* webpackChunkName: "common" */ '@/views/Author'); 

/**
 * 登录或者绑定手机号,忘记密码，注册
 */
const Bind = () => import(/* webpackChunkName: "common" */ '@/views/Bind'); 
const Login = () => import(/* webpackChunkName: "common" */ '@/views/Login'); 
const Forget = () => import(/* webpackChunkName: "common" */ '@/views/Forget'); 
const Register = () => import(/* webpackChunkName: "common" */ '@/views/Register'); 
const Invite = () => import(/* webpackChunkName: "common" */ '@/views/invite/Index'); 



/***
 * 视频相关的页面
 */
const VideoIndex = () => import(/* webpackChunkName: "video" */ '@/views/video/VideoIndex'); 
const VideoSearch = () => import(/* webpackChunkName: "video" */ '@/views/video/VideoSearch'); 


/**
 * 旅游线路
 */
const TravelLine = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelLine'); 
// const TravelGuide = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelGuide');
const TravelGuide = () => import(/* webpackChunkName: "travel" */ '@/views/travel/v2/Guide');
const TravelCustome = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelCustome');
const TravelSelect = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelSelect');
const TravelCommit = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelCommit');
const TravelFindDetail = () => import(/* webpackChunkName: "travel" */ '@/views/travel/TravelFindDetail');
/**
 * 地址
 */
const AddressSelect = () => import(/* webpackChunkName: "address" */ '@/views/address/AddressSelect');
const AddressAction = () => import(/* webpackChunkName: "address" */ '@/views/address/AddressAction');


/**
 * 用户
 */
const UserIndex = () => import(/* webpackChunkName: "user" */ '@/views/user/UserIndex'); 
const UserOrderList = () => import(/* webpackChunkName: "user" */ '@/views/user/UserOrderList'); 
const UserOrderDetail = () => import(/* webpackChunkName: "user" */ '@/views/user/UserOrderDetail'); 
const UserWallet = () => import(/* webpackChunkName: "user" */ '@/views/user/UserWallet'); 
const UserAddressList = () => import(/* webpackChunkName: "user" */ '@/views/user/UserAddress'); 
const UserAddressAction = () => import(/* webpackChunkName: "user" */ '@/views/user/UserAddressAction'); 



/**
 * home
 */
const Index = () => import(/* webpackChunkName: "home" */ '@/views/Home/Index');
const Classify = () => import(/* webpackChunkName: "home" */ '@/views/Home/Classify');

/**
 * 文旅详情
 */
const CulturaDetail = () => import(/* webpackChunkName: "common" */ '@/views/cultura/CulturaDetail');


/**
 * 城市选择
 */
const CitySelect = () => import(/* webpackChunkName: "common" */ '@/views/CitySelect');

/**
 * im
 */
const IMIndex = () => import(/* webpackChunkName: "im" */ '@/views/IM/Index');


/**
 * test
 */
const Test = () => import(/* webpackChunkName: "common" */ '@/views/Test');

/**
 * 支付
 */
const Pay = () => import(/* webpackChunkName: "common" */ '@/views/pay/PaySelect');
const PayState = () => import(/* webpackChunkName: "common" */ '@/views/pay/PayState');

/**
 * 订单
 */
const OrderPlace = () => import(/* webpackChunkName: "order" */ '@/views/order/OrderPlace');
const OrderCommit = () => import(/* webpackChunkName: "order" */ '@/views/order/OrderCommit'); 
const OrderAfterSale = () => import(/* webpackChunkName: "order" */ '@/views/order/OrderAfterSale'); 
const OrderRefund = () => import(/* webpackChunkName: "order" */ '@/views/order/OrderRefund'); 
const OrderCustom = () => import(/* webpackChunkName: "order" */ '@/views/order/OrderCustom'); 



/**
 * 反馈
 */
const Feedback = () => import(/* webpackChunkName: "common" */ '@/views/Feedback'); 

/**
 * 提现相关
 */
const WithDrawIndex = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawIndex'); 
const WithDrawAccountAction = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawAccountAction'); 
const WithDrawAccountList = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawAccountList'); 
const WithDrawOrder = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawOrder'); 
const WithDrawList = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawList'); 
const WithDrawTransaction = () => import(/* webpackChunkName: "withdraw" */ '@/views/withdraw/WithDrawTransaction'); 


/**
 * 商家
 */
const ShopOrderList = () => import(/* webpackChunkName: "shop" */ '@/views/shop/ShopOrderList'); 
const ShopOrderDetail = () => import(/* webpackChunkName: "shop" */ '@/views/shop/ShopOrderDetail'); 


/**
 * 活动
 */
const  ActivityIndex = () => import(/* webpackChunkName: "activity" */ '@/views/activity/Index');

/***
 * 合伙人
 */
const PartnerIndex = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Index')
const PartnerGuide = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Guide')
const PartnerGuideEnter = () => import(/* webpackChunkName: "partner" */ '@/views/partner/GuideEnter')
const PartnerLine = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Line')
const PartnerOrder = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Order')
const PartnerRefund = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Refund')
const PartnerWithdraw = () => import(/* webpackChunkName: "partner" */ '@/views/partner/Withdraw')

//tab
const Tabbar = () => import(/* webpackChunkName: "common" */ '@/views/home/Tabbar')

//商品
const GoodIndx = () => import(/* webpackChunkName: "goods" */ '@/views/good/Index')
const GoodSelect = () => import(/* webpackChunkName: "goods" */ '@/views/good/Select')
const GoodPlace = () => import(/* webpackChunkName: "goods" */ '@/views/good/Place')
const GoodLogistics = () => import(/* webpackChunkName: "goods" */ '@/views/good/Logistics')



//群
const GroupIndex = () => import(/* webpackChunkName: "goods" */ '@/views/group/Index')

//打开外部浏览器的提示
const BrowserIndex = () => import(/* webpackChunkName: "goods" */ '@/views/browser/Index')

//邀请朋友
const InviteFriend = () => import(/* webpackChunkName: "goods" */ '@/views/invite/Friend')
//邀请完下载
const Download = () => import(/* webpackChunkName: "goods" */ '@/views/invite/Download')


//旅居
const HouseIndex = () => import(/* webpackChunkName: "house" */ '@/views/house/Index')

//地图
const MapIndex = () => import(/* webpackChunkName: "house" */ '@/views/map/Index')

//协议
const ProtocolIndex = () => import(/* webpackChunkName: "house" */ '@/views/Protocol')

//酒店
const HotelIndex = () => import(/* webpackChunkName: "hotel" */ '@/views/hotel/Index')
const HotelSelect = () => import(/* webpackChunkName: "hotel" */ '@/views/hotel/HotelSelect')
const HotelOrderPlace = () => import(/* webpackChunkName: "hotel" */ '@/views/hotel/OrderPlace');

//促销
const PromotionIndex = () => import(/* webpackChunkName: "hotel" */ '@/views/promotion/Index')
const PromotionIndex2 = () => import(/* webpackChunkName: "hotel" */ '@/views/promotion/Index2')
const PromotionPlace = () => import(/* webpackChunkName: "hotel" */ '@/views/promotion/Place')


Vue.use(Router)

export default new Router({
  routes: [{
      path:'/',
      redirect:'/classify',
      component:Tabbar,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      },
      children:[{
        path:'index',
        name:'Index',
        component:Index,
        meta: {
          requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
          keepAlive:false
        }
      },{
        path:'classify',
        name:'Classify',
        component:Classify,
        meta: {
          requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
          keepAlive:false
        }
      },{
        path:'myself',
        name:'Myself',
        component:UserIndex,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
          keepAlive:false      
        }
      }]
    }
    // ,{
    //   path:'/index',
    //   name:'Index',
    //   component:Index,
    //   meta: {
    //     requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
    //     keepAlive:false
    //   }
    // },{
    //   path:'/classify',
    //   name:'Classify',
    //   component:Classify,
    //   meta: {
    //     requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
    //     keepAlive:false
    //   }
    // }
    ,{
      path:'/bind',
      name:'BindPhone',
      component:Bind,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/login',
      name:'Login',
      component:Login,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/author',
      name:'Author',
      component:Author,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/video/:id',
      name: 'VideoIndex',
      component: VideoIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/videosearch',
      name: 'VideoSearch',
      component: VideoSearch,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/line/:id',
      name: 'TravelLine',
      component: TravelLine,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/find/:id',
      name: 'TravelFindDetail',
      component: TravelFindDetail,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/guide/:id',
      name: 'TravelGuide',
      component: TravelGuide,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/guideCommit/:id',
      name: 'GuideCommit',
      component: OrderCommit,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/select/:id',
      name: 'TravelSelect',
      component: TravelSelect,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/custome/:id',
      name: 'TravelCustome',
      component: TravelCustome,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/commitList/:id',
      name: 'TravelCommit',
      component: TravelCommit,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/place',
      name: 'OrderPlace',
      component: OrderPlace,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/address/select',
      name: 'AddressSelect',
      component: AddressSelect,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/address/:type',
      name: 'AddressAction',
      component: AddressAction,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path:'/user/:id',
      name:'UserIndex',
      component:UserIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path:'/wallet',
      name:'UserWallet',
      component:UserWallet,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/myOrder',
      name:'UserOrderList',
      component:UserOrderList,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/order/:no',
      name:'UserOrderDetail',
      component:UserOrderDetail,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/commit/:no',
      name:'OrderCommit',
      component:OrderCommit,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/aftersale/:no',
      name:'OrderAfterSale',
      component:OrderAfterSale,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/refund/:no',
      name:'OrderRefund',
      component:OrderRefund,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/orderCustom/:no',
      name:'OrderCustom',
      component:OrderCustom,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/feedback',
      name:'Feedback',
      component:Feedback,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/city',
      name:'CitySelect',
      component:CitySelect,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/im/index',
      name:'IMIndex',
      component:IMIndex,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/pay/:no',
      name:'Pay',
      component:Pay,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/payState/:no',
      name:'PayState',
      component:PayState,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/culturaDetail',
      name:'CulturaDetail',
      component:CulturaDetail,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/withdraw',
      name:'WithDrawIndex',
      component:WithDrawIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/account/:type',
      name:'WithDrawAccountAction',
      component:WithDrawAccountAction,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/accountList',
      name:'WithDrawAccountList',
      component:WithDrawAccountList,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/withdraworder',
      name:'WithDrawOrder',
      component:WithDrawOrder,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/withdrawlist',
      name:'WithDrawList',
      component:WithDrawList,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/transaction',
      name:'WithDrawTransaction',
      component:WithDrawTransaction,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/shoporderlist',
      name:'ShopOrderList',
      component:ShopOrderList,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/shoporderdetail/:no',
      name:'ShopOrderDetail',
      component:ShopOrderDetail,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/test',
      name:'Test',
      component:Test,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/activity/:id',
      name:'Activity',
      component:ActivityIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/forget',
      name:'Forget',
      component:Forget,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/register',
      name:'Register',
      component:Register,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/index',
      name:'PartnerIndex',
      component:PartnerIndex,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/guide',
      name:'PartnerGuide',
      component:PartnerGuide,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/guideEnter',
      name:'PartnerGuideEnter',
      component:PartnerGuideEnter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/company',
      name:'PartnerCompany',
      component:PartnerGuide,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/companyEnter',
      name:'PartnerCompanyEnter',
      component:PartnerGuideEnter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/line',
      name:'PartnerLine',
      component:PartnerLine,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/order',
      name:'PartnerOrder',
      component:PartnerOrder,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/refund',
      name:'PartnerRefund',
      component:PartnerRefund,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/partner/widthdraw',
      name:'PartnerWithdraw',
      component:PartnerWithdraw,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/good/:id',
      name:'GoodIndx',
      component:GoodIndx,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/goodSelect/:id',
      name:'GoodSelect',
      component:GoodSelect,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/goodPlace/:id',
      name:'GoodPlace',
      component:GoodPlace,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/logistics/:id',
      name:'GoodLogistics',
      component:GoodLogistics,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/addressList',
      name:'UserAddressList',
      component:UserAddressList,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/addressAction',
      name:'UserAddressAction',
      component:UserAddressAction,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/invite',
      name:'Invite',
      component:Invite,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/group/:id',
      name:'GroupIndex',
      component:GroupIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/browser',
      name:'BrowserIndex',
      component:BrowserIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/invitefriend/:id',
      name:'InviteFriend',
      component:InviteFriend,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/invitedownload/:id',
      name:'InviteDownload',
      component:Download,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/house/:id',
      name:'HouseIndex',
      component:HouseIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/map',
      name:'MapIndex',
      component:MapIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/protocol',
      name:'ProtocolIndex',
      component:ProtocolIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path:'/hotel/:id',
      name:'HotelIndex',
      component:HotelIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/hotelSelect/:id',
      name: 'HotelSelect',
      component: HotelSelect,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false      
      }
    },{
      path: '/hotelPlace/:id',
      name: 'HotelOrderPlace',
      component: HotelOrderPlace,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/promotionIndex/:id',
      name: 'PromotionIndex',
      component: PromotionIndex,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/promotionPlace/:id',
      name: 'PromotionPlace',
      component: PromotionPlace,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    },{
      path: '/promotionIndex2/:id',
      name: 'PromotionIndex2',
      component: PromotionIndex,
      meta: {
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要微信认证的
        keepAlive:false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js